import { useEffect, useRef } from 'react';

const GOOGLE_MAPS_API_KEY = 'YOUR_GOOGLE_MAPS_API_KEY'; // Substitua pela sua chave

const RastreioPage = () => {
  const mapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}`;
      script.async = true;
      script.onload = initMap;
      document.body.appendChild(script);
    } else {
      initMap();
    }
    function initMap() {
      if (mapRef.current && window.google) {
        new window.google.maps.Map(mapRef.current, {
          center: { lat: -14.235004, lng: -51.92528 }, // Centro do Brasil
          zoom: 4,
        });
      }
    }
  }, []);

  return (
    <div className="flex flex-col h-full w-full">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Rastreamento de Veículos</h1>
      <div ref={mapRef} style={{ width: '100%', height: '70vh', borderRadius: '12px', boxShadow: '0 2px 8px #0001' }} />
      <p className="mt-4 text-gray-600">O mapa acima está pronto para exibir a localização dos veículos em tempo real.</p>
    </div>
  );
};

export default RastreioPage;
